import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { isMobileContext } from '../context/isMobileContext';
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import { Navigation } from "swiper";
import CertificationsCard from './CertificationsCard';
const Certifications = () => {
    const { isMobile } = useContext(isMobileContext);
    const { t,i18n } = useTranslation();
    const tableData = [
        t("partnersCertifications.t1"),
        t("partnersCertifications.t2"),
        t("partnersCertifications.t3"),
        t("partnersCertifications.t4"),
        t("partnersCertifications.t5"),
        t("partnersCertifications.t6"),
        t("partnersCertifications.t7"),
        t("partnersCertifications.t8"),
        t("partnersCertifications.t9"),
        t("partnersCertifications.t10"),
        t("partnersCertifications.t11"),
        t("partnersCertifications.t12"),
        t("partnersCertifications.t13"),
        t("partnersCertifications.t14"),
        t("partnersCertifications.t15"),
        t("partnersCertifications.t16"),
        t("partnersCertifications.t17"),
        t("partnersCertifications.t18"),
        t("partnersCertifications.t19"),
        t("partnersCertifications.t20"),
        t("partnersCertifications.t21"),
        t("partnersCertifications.t22"),
        t("partnersCertifications.t23"),
        ""

    ]
    //to divide array into small arrays
    const dividedArrays = (array, data_size) =>
        Array(Math.ceil(array.length / data_size))
            .fill()
            .map((_, index) => index * data_size)
            .map((begin) => tableData.slice(begin, begin + data_size))
    const tableDataMobile = dividedArrays(tableData, 4)
    return (
        <div className='certifications-section'>
            <div className='first-bg'>
                <img
                    src={process.env.PUBLIC_URL + '/imgs/appendices/c-bg1.png'}
                    alt='background'
                />
            </div>
            <div className='second-bg'>
                <img
                    src={process.env.PUBLIC_URL + '/imgs/appendices/c-bg1.png'}
                    alt='background'
                />
            </div>
            <div className='third-bg'>
                <img
                    src={process.env.PUBLIC_URL + '/imgs/appendices/c-bg2.png'}
                    alt='background'
                />
            </div>
            <div className='fourth-bg'>
                <img
                    src={process.env.PUBLIC_URL + '/imgs/appendices/c-bg3.png'}
                    alt='background'
                />
            </div>
            <div className='header-section'>
                    <div className="first-line">
                        <div className="title">
                            <motion.h2
                            initial={{ opacity: 0, translateY: "100%" }}
                            whileInView={{ opacity: 1, translateY: 0 }}
                            viewport={{ once: true }}
                            transition={{ ease: "easeInOut", delay: isMobile ? 0.1 : 0.2, duration: 0.5 }}
                            >
                                {t("partnersCertifications.accreditations")}
                            </motion.h2>
                        </div>
                        {/* <div className="and">
                            <motion.h2
                                initial={{ opacity: 0, translateY: "100%" }}
                                whileInView={{ opacity: 1, translateY: 0 }}
                                viewport={{ once: true }}
                                transition={{ ease: "easeInOut", delay: isMobile ? 0.3 : 0.2, duration: 0.5 }}
                            >{t("partnersCertifications.and")}</motion.h2>
                        </div> */}
                    </div>
                <div className="second-line">
                    <motion.h2
                        initial={{ opacity: 0, translateY: "100%" }}
                        whileInView={{ opacity: 1, translateY: 0 }}
                        viewport={{ once: true }}
                        transition={{ ease: "easeInOut", delay: isMobile ? 0.5 : 0.4, duration: 0.5 }}
                    >{t("partnersCertifications.certifications")}</motion.h2>
                </div>
            </div>
            {isMobile ?
                <div className='cards-container'>
                    <Swiper
                        key={Math.random(0, 100)}
                        centeredSlides={true}
                        style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                                // spaceBetween: 25,
                            },
                        }}
                        modules={[Navigation]}
                        navigation={{
                            nextEl: `.certification-next`,
                            prevEl: `.certification-prev`,
                        }}
                        className="certification-swiper"
                    >
                        {tableDataMobile.map((data, index) => (
                            <SwiperSlide key={index}>
                                <CertificationsCard
                                    key={index}
                                    i={index}
                                    tableData={data}
                                />
                            </SwiperSlide>
                        ))}

                    </Swiper>
                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{
                            ease: "easeInOut",
                            delay: .2,
                            duration: 0.5,
                        }}
                        className="certification-navigation-container">
                        <div className="swiper-button-prev certification-prev"></div>
                        <div className="swiper-button-next certification-next"></div>
                    </motion.div>
                </div>
                :
                <motion.div className='table-container'>
                    <motion.div className='table'>
                        <ol>
                            {tableData.map((data, index) => (
                                index <= 11 &&
                                <motion.li
                                    initial={{ opacity: 0 }}
                                    whileInView={{ opacity: 1 }}
                                    viewport={{ once: true }}
                                    transition={{ ease: "easeInOut", delay: .15, duration: 0.5 }}
                                    key={index}> <span>{index < 9 ? `0${index + 1} ` : index + 1}</span> {data}</motion.li>
                            ))}
                        </ol>
                        <ol>
                            {tableData.map((data, index) => (
                                index > 11 &&
                                <motion.li
                                    initial={{ opacity: 0 }}
                                    whileInView={{ opacity: 1 }}
                                    viewport={{ once: true }}
                                    transition={{ ease: "easeInOut", delay: .15, duration: 0.5 }}
                                    key={index}>
                                    {data !== "" && <span>{index + 1}</span>}
                                    {data}</motion.li>
                            ))}
                        </ol>
                    </motion.div>
                </motion.div>
            }
        </div>
    )
}

export default Certifications
